module.exports = __webpack_public_path__ + "imgs/mj-card-background.baa18d4fba0af55c53b9c37675739999.png";